import { TokenAmount, TokenAmountProps } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { CurrencyBalanceContext } from '../Contexts'

const Balance: React.FC<TokenAmountProps> = (props) => {
  const { balance, refresh } = useContext(CurrencyBalanceContext)

  const onClick = () => {
    refresh?.()
  }

  return <TokenAmount amount={balance} label="BAL" onClick={onClick} title="Balance (Total amount of XYO in this account)" {...props} />
}

export default Balance
